<template>
  <div id="results-subview" class="py-1" style="min-height: calc(100vh - 50px)">
    <b-container v-if="loading">
      <b-row>
        <b-col class="loadingScreen">
          <div></div>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="!loading && !currentEngagementReport">
      <b-row align-v="center" align-h="center" class="mt-0 mt-md-5">
        <b-col cols="12" sm="12" md="6" lg="5">
          <div class="panel-light p-5">
            <h5>{{$t('personal-results:no-results')}}</h5>
            <b-button class="mt-3" style="text-shadow: none;" variant="light" to="/personal/survey">{{$t('personal-results:no-results-cta')}}</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="!loading && currentEngagementReport" fluid style="max-width: 1400px; margin: auto;" :class="{'overlayed': $route.name != 'Results'}">
      <b-row no-gutters class="mt-3">
        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/personal/results/engagement')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-total']) }">
              <span class="text-center" style="color: white;">
                <!-- <h3>{{$t('personal-results:title-uwes')}}</h3> -->
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-total'].avg)) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-total'])}}</p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_engagement.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('personal-results:title-uwes')}}</h5>
              <div style="flex-grow: 1;">
                <!-- <h6><span>{{ $t('personal-results:total-categorical-title-' + currentEngagementReport.categories['uwes9-total']) }}</span></h6> -->
                <h6><span>{{ $t('personal-results:description-uwes') }}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/personal/results/engagement">{{$t('personal-results:view-results')}}</b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/personal/results/vigor')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-vigor']) }">
              <span class="text-center" style="color: white;">
                <!-- <h3>{{$t('common:title-vigor')}}</h3> -->
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-vigor'].avg)) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-vigor'])}}</p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_vigor.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-vigor')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-personal-vigor')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/personal/results/vigor">{{$t('personal-results:view-results')}}</b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/personal/results/absorption')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-absorption']) }">
              <span class="text-center" style="color: white;">
                <!-- <h3>{{$t('common:title-absorption')}}</h3> -->
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-absorption'].avg)) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-absorption'])}}</p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_absorption.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-absorption')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-personal-absorption')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/personal/results/absorption">{{$t('personal-results:view-results')}}</b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/personal/results/dedication')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-dedication']) }">
              <span class="text-center" style="color: white;">
                <!-- <h3>{{$t('common:title-dedication')}}</h3> -->
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-dedication'].avg)) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-dedication'])}}</p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_dedication.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-dedication')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-personal-dedication')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/personal/results/dedication">{{$t('personal-results:view-results')}}</b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/personal/results/anxiety')">
            <div class="mb-2 py-2 pt-3 rounded-top" style="background-color: #ccc;">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 69px;"><icon name="eye-slash" size="lg" style="height: 1em; width: auto; max-width: 100%; max-height: 100%; font-size: 36px;"/></big></p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_anxiety.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t(`personal-results:title-anxiety-gad-7`)}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('personal-results:description-anxiety-gad-7')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/personal/results/anxiety">{{$t('personal-results:view-results')}}</b-button>
            </div>
          </div>
        </b-col>
        <b-col v-if="account && account.accountSetup && account.accountSetup.capabilities && account.accountSetup.capabilities.scales && account.accountSetup.capabilities.scales.indexOf('psychosocial-workload-organizing-work') > -1" cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/personal/results/psychosocial-workload')">
            <div class="mb-2 py-2 pt-3 rounded-top" style="background-color: #ccc;">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 69px;"><icon name="eye-slash" size="lg" style="height: 1em; width: auto; max-width: 100%; max-height: 100%; font-size: 36px;"/></big></p>
              </span>
            </div>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">Työn kuormitustekijät</h5>
              <div style="flex-grow: 1;">
                <h6><span>Kaikessa työssä on kuormittavia asioita ja kuormitus on usein myös vaihtelevaa. Tässä raportissa käydään läpi oma arviosi kuormitustekijöistä ja niiden merkittävyydestä.</span></h6>
              </div>
              <!-- <h5 class="info-headline">{{$t(`personal-results:title-psychosocial-workload`)}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('personal-results:description-psychosocial-workload')}}</span></h6>
              </div> -->
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/personal/results/psychosocial-workload">{{$t('personal-results:view-results')}}</b-button>
            </div>
          </div>
        </b-col>
        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3" v-if="currentSatisfactionReport && currentSatisfactionReport.satisfaction">
          <div class="card insight-card">
            <img class="card-img-top" src="/img/illustrations/reports/theme_satisfaction.jpg"/>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-satisfaction')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('personal-results:satisfaction-categorical-title-'+currentSatisfactionReport.satisfaction[0].class)}}</span></h6>
              </div>
            </div>
          </div>
        </b-col> -->
        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3" v-if="currentRecommendationReport && currentRecommendationReport.recommendation">
          <div class="card insight-card">
            <img class="card-img-top" src="/img/illustrations/reports/theme_recommendation.jpg"/>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-recommendation')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('personal-results:recommendation-categorical-title-'+currentRecommendationReport.recommendation[0].class)}}</span></h6>
              </div>
            </div>
          </div>
        </b-col> -->
      </b-row>
    </b-container>
    <div class="subnav text-center" v-if="$route.name != 'Results'" >
      <b-button style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) === 0" variant="link"  :to="availableReports[availableReports.indexOf(openedReport)-1]"><icon name="angle-left"/></b-button>
      <span class="subnav-progress">
        <router-link class="item" :key="index" v-for="(report, index) in availableReports" :class="{'active': report === openedReport}" :to="report"></router-link>
      </span>
      <b-button style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) >= availableReports.length -1" variant="link" :to="availableReports[availableReports.indexOf(openedReport)+1]"><icon name="angle-right"/></b-button>
      <b-button variant="link" to="/personal/results" style="position: absolute; right: 0;"><icon name="times"/></b-button>
    </div>
    <transition name="zoom" mode="in-out" enter-active-class="zoom-enter-active">
      <router-view v-touch:swipe="swipeHandler"/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'
// import BarChart from '../common/barchart/BarChart'

export default {
  components: {
    // 'barchart': BarChart
  },
  data () {
    return {
      currentEngagementReport: null,
      currentCompanyEngagementReport: null,
      loadingEngagementReport: true,
      loadingCompanyEngageentReport: true,
      // currentSatisfactionReport: null,
      // testingLevels: ['erittäin matala', 'matala', 'hyvä', 'korkea', 'erittäin korkea'],
      basicReports: ['engagement', 'vigor', 'absorption', 'dedication', 'anxiety'],
      openedReport: null
    }
  },
  created: function () {
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.transitionName === 'zoom') {
        document.body.style.overflow = 'hidden'
      }
      if (from.meta.transitionName === 'zoom') {
        document.body.style.overflow = 'auto'
      }
      next()
    })
  },
  mounted: function () {
    // this.$store.dispatch('loadPendingQuestions')
    this.loadCurrentEngagementReport()
    // this.loadSatisfactionReport()
    this.loadCurrentCompanyEngagementReport()
  },
  methods: {
    uwesToIndex (uwes) { return this.formatNumber0(uwes / 6.0 * 100) },
    loadCurrentEngagementReport () {
      this.loadingEngagementReport = true
      this.axios.get('/stats/user/current/engagement').then((response) => {
        if (response.data.updatedAt) {
          this.currentEngagementReport = response.data
        }
        // TESTING
        // this.currentEngagementReport.previous.total.class = 'very-high'
        // this.currentEngagementReport.previous.total.avg = 5.666666
        // this.currentEngagementReport.previous.vigor.class = 'high'
        // this.currentEngagementReport.previous.vigor.avg = 4.8666666666666667
        // this.currentEngagementReport.previous.absorption.class = 'very-low'
        // this.currentEngagementReport.previous.absorption.avg = 1.8666666666666667
      }).catch(() => {
      }).finally(() => { this.loadingEngagementReport = false })
    },
    // loadSatisfactionReport () {
    //   this.loadingSatisfactionReport = true
    //   this.axios.get('/stats/user/current/satisfaction').then((response) => {
    //     if (response.data) {
    //       this.currentSatisfactionReport = response.data
    //     }
    //   }).catch(err => {
    //     console.log(err)
    //   }).finally(() => { this.loadingSatisfactionReport = false })
    // },
    loadCurrentCompanyEngagementReport () {
      this.loadingCompanyEngageentReport = true
      this.axios.get('/stats/current/engagement').then((response) => {
        if (response.data.categories && response.data.categories['uwes9-total']) {
          this.currentCompanyEngagementReport = response.data
          // TODO: check the backend that it doesn't return empty stuff
        }
      }).catch(() => {
      }).finally(() => { this.loadingCompanyEngageentReport = false })
    },
    formatNumber (value) {
      return numeral(value).format('0.00')
    },
    formatNumber1 (value) {
      return numeral(value).format('0.0')
    },
    formatNumber0 (value) {
      return numeral(value).format('0')
    },
    formatPercent (value) {
      return numeral(value).format('0%')
    },
    mapColor: function (uwesClass) {
      const colors = {
        'very-high': '#377771',
        high: '#4ce0b3',
        average: '#ffce4c',
        low: '#ff8e72',
        'very-low': '#ed6a5e'
        // 'very-high': '#62c829',
        // high: '#a6e682',
        // average: '#8ed7da',
        // low: '#f39c9d',
        // 'very-low': '#e63333'
      }
      return colors[uwesClass]
    },
    getPersonalTeamUWESDifference: function () {
      if (this.hasDataForTotalComparison) {
        return this.currentEngagementReport.stats['uwes9-total'].avg - this.currentCompanyEngagementReport.stats['uwes9-total'].avg
      }
      return null
    },
    getPersonalTeamVigorDifference: function () {
      if (this.hasDataForVigorComparison) {
        return this.currentEngagementReport.stats['uwes9-vigor'].avg - this.currentCompanyEngagementReport.stats['uwes9-vigor']
      }
      return null
    },
    getPersonalTeamAbsorptionDifference: function () {
      if (this.hasDataForAbsorptionComparison) {
        return this.currentEngagementReport.stats['uwes9-absorption'].avg - this.currentCompanyEngagementReport.stats['uwes9-absorption']
      }
      return null
    },
    getPersonalTeamDedicationDifference: function () {
      if (this.hasDataForDedicationComparison) {
        return this.currentEngagementReport.stats['uwes9-dedication'].avg - this.currentCompanyEngagementReport.stats['uwes9-dedication']
      }
      return null
    },
    getUWESDifferenceDegree: function () {
      if (!this.hasDataForTotalComparison) {
        return null
      } else if (this.getPersonalTeamUWESDifference() === 0) {
        return 0
      }
      // Converts any difference normalized to 0 - 100 into a 1 - 5 degree of difference
      return Math.round(Math.log((Math.abs(this.getPersonalTeamUWESDifference())) / 6.0 * 100.0 + 0.5))
    },
    getVigorDifferenceDegree: function () {
      if (!this.hasDataForVigorComparison) {
        return null
      } else if (this.getPersonalTeamVigorDifference() === 0) {
        return 0
      }
      // Converts any difference normalized to 0 - 100 into a 1 - 5 degree of difference
      return Math.round(Math.log((Math.abs(this.getPersonalTeamVigorDifference())) / 6.0 * 100.0 + 0.5))
    },
    getAbsorptionDifferenceDegree: function () {
      if (!this.hasDataForAbsorptionComparison) {
        return null
      } else if (this.getPersonalTeamAbsorptionDifference() === 0) {
        return 0
      }
      // Converts any difference normalized to 0 - 100 into a 1 - 5 degree of difference
      return Math.round(Math.log((Math.abs(this.getPersonalTeamAbsorptionDifference())) / 6.0 * 100.0 + 0.5))
    },
    getDedicationDifferenceDegree: function () {
      if (!this.hasDataForDedicationComparison) {
        return null
      } else if (this.getPersonalTeamDedicationDifference() === 0) {
        return 0
      }
      // Converts any difference normalized to 0 - 100 into a 1 - 5 degree of difference
      return Math.round(Math.log((Math.abs(this.getPersonalTeamDedicationDifference())) / 6.0 * 100.0 + 0.5))
    },
    swipeHandler (direction) {
      if (direction === 'right' && this.availableReports.indexOf(this.openedReport) !== 0) {
        this.$router.push(this.availableReports[this.availableReports.indexOf(this.openedReport) - 1])
      }
      if (direction === 'left' && this.availableReports.indexOf(this.openedReport) < this.availableReports.length - 1) {
        this.$router.push(this.availableReports[this.availableReports.indexOf(this.openedReport) + 1])
      }
    }
  },
  computed: {
    ...mapGetters(['account']),
    availableReports: function () {
      const reports = this.basicReports
      if (this.account && this.account.accountSetup && this.account.accountSetup.capabilities.scales && this.account.accountSetup.capabilities.scales.indexOf('psychosocial-workload-organizing-work') > -1) {
        reports.push('psychosocial-workload')
      }
      return reports
    },
    loading: function () {
      return this.loadingEngagementReport === true || this.loadingCompanyEngageentReport === true // || this.currentSatisfactionReport === null
    },
    hasDataForTotalComparison: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats['uwes9-total'] && this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-total']) {
        return true
      }
      return false
    },
    hasDataForVigorComparison: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats['uwes9-vigor'] && this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-vigor']) {
        return true
      }
      return false
    },
    hasDataForAbsorptionComparison: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats['uwes9-absorption'] && this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-absorption']) {
        return true
      }
      return false
    },
    hasDataForDedicationComparison: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats['uwes9-dedication'] && this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-dedication']) {
        return true
      }
      return false
    },
    personalUWESPercent: function () {
      if (this.currentEngagementReport) {
        return this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].avg / 6.0)
      }
      return this.formatPercent(0)
    },
    companyUWESPercent: function () {
      if (this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-total']) {
        return this.formatPercent(this.currentCompanyEngagementReport.stats['uwes9-total'].avg / 6.0)
      }
      return this.formatPercent(0)
    },
    companyVigorPercent: function () {
      if (this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-vigor']) {
        return this.formatPercent(this.currentCompanyEngagementReport.stats['uwes9-vigor'] / 6.0)
      }
      return this.formatPercent(0)
    },
    companyAbsorptionPercent: function () {
      if (this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-absorption']) {
        return this.formatPercent(this.currentCompanyEngagementReport.stats['uwes9-absorption'] / 6.0)
      }
      return this.formatPercent(0)
    },
    companyDedicationPercent: function () {
      if (this.currentCompanyEngagementReport && this.currentCompanyEngagementReport.stats && this.currentCompanyEngagementReport.stats['uwes9-dedication']) {
        return this.formatPercent(this.currentCompanyEngagementReport.stats['uwes9-dedication'] / 6.0)
      }
      return this.formatPercent(0)
    },
    uwesTotalChange: function () {
      if (this.currentEngagementReport === undefined || this.currentEngagementReport.stats['uwes9-total'] === undefined || this.currentEngagementReport.previous === undefined || this.currentEngagementReport.previous.total === undefined || this.currentEngagementReport.previous.total.avg === undefined) {
        return null
      } else {
        const change = this.currentEngagementReport.stats['uwes9-total'].avg - this.currentEngagementReport.previous.total.avg
        return change
      }
    },
    uwesVigorChange: function () {
      if (this.currentEngagementReport === undefined || this.currentEngagementReport.stats['uwes9-vigor'].avg === undefined || this.currentEngagementReport.previous === undefined || this.currentEngagementReport.previous.vigor === undefined || this.currentEngagementReport.previous.vigor.avg === undefined) {
        return null
      } else {
        const change = this.currentEngagementReport.stats['uwes9-vigor'].avg - this.currentEngagementReport.previous.vigor.avg
        return change
      }
    },
    uwesAbsorptionChange: function () {
      if (this.currentEngagementReport === undefined || this.currentEngagementReport.stats['uwes9-absorption'].avg === undefined || this.currentEngagementReport.previous === undefined || this.currentEngagementReport.previous.absorption === undefined || this.currentEngagementReport.previous.absorption.avg === undefined) {
        return null
      } else {
        const change = this.currentEngagementReport.stats['uwes9-absorption'].avg - this.currentEngagementReport.previous.absorption.avg
        return change
      }
    },
    uwesDedicationChange: function () {
      if (this.currentEngagementReport === undefined || this.currentEngagementReport.stats['uwes9-dedication'].avg === undefined || this.currentEngagementReport.previous === undefined || this.currentEngagementReport.previous.dedication === undefined || this.currentEngagementReport.previous.dedication.avg === undefined) {
        return null
      } else {
        const change = this.currentEngagementReport.stats['uwes9-dedication'].avg - this.currentEngagementReport.previous.dedication.avg
        return change
      }
    },
    currentDirectionDegree: function () {
      if (this.uwesTotalChange !== null) {
        if (this.uwesTotalChange === 0) {
          return 0
        }
        return Math.round(Math.log(Math.abs(this.uwesTotalChange) / 6.0 * 100.0 + 0.5))
      }
      return null
    },
    currentVigorDirectionDegree: function () {
      if (this.uwesVigorChange !== null) {
        if (this.uwesVigorChange === 0) {
          return 0
        }
        return Math.round(Math.log(Math.abs(this.uwesVigorChange) / 6.0 * 100.0 + 0.5))
      }
      return null
    },
    currentAbsorptionDirectionDegree: function () {
      if (this.uwesAbsorptionChange !== null) {
        if (this.uwesAbsorptionChange === 0) {
          return 0
        }
        return Math.round(Math.log(Math.abs(this.uwesAbsorptionChange) / 6.0 * 100.0 + 0.5))
      }
      return null
    },
    currentDedicationDirectionDegree: function () {
      if (this.uwesDedicationChange !== null) {
        if (this.uwesDedicationChange === 0) {
          return 0
        }
        return Math.round(Math.log(Math.abs(this.uwesDedicationChange) / 6.0 * 100.0 + 0.5))
      }
      return null
    },
    currentDirectionClass: function () {
      if (this.uwesTotalChange === null) {
        return null
      } else {
        const direction = this.uwesTotalChange > 0 ? 'up' : (this.uwesTotalChange < 0 ? 'down' : 'no-change')
        const degree = this.currentDirectionDegree
        if (degree !== null) {
          return `${direction}-${degree}`
        } else {
          return direction
        }
      }
    },
    currentVigorDirectionClass: function () {
      if (this.uwesVigorChange === null) {
        return null
      } else {
        const direction = this.uwesVigorChange > 0 ? 'up' : (this.uwesVigorChange < 0 ? 'down' : 'no-change')
        const degree = this.currentVigorDirectionDegree
        if (degree !== null) {
          return `${direction}-${degree}`
        } else {
          return direction
        }
      }
    },
    currentAbsorptionDirectionClass: function () {
      if (this.uwesAbsorptionChange === null) {
        return null
      } else {
        const direction = this.uwesAbsorptionChange > 0 ? 'up' : (this.uwesAbsorptionChange < 0 ? 'down' : 'no-change')
        const degree = this.currentAbsorptionDirectionDegree
        if (degree !== null) {
          return `${direction}-${degree}`
        } else {
          return direction
        }
      }
    },
    currentDedicationDirectionClass: function () {
      if (this.uwesDedicationChange === null) {
        return null
      } else {
        const direction = this.uwesDedicationChange > 0 ? 'up' : (this.uwesDedicationChange < 0 ? 'down' : 'no-change')
        const degree = this.currentDedicationDirectionDegree
        if (degree !== null) {
          return `${direction}-${degree}`
        } else {
          return direction
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>
